window.onload = function() {
    /* check for iframes */
    if (document.getElementsByTagName('iframe').length > 0) {
        /* get current url */
        const url = window.location.href

        /* iterate over iframes */
        Array.from(document.getElementsByTagName('iframe')).forEach((iframe) => {
            /* does src contain the url */
            if( iframe.src.indexOf("www2.xppower.com") >= 0) {
                /* set target iframe */
                const contentWindow = iframe.contentWindow

                /* send current page url via postMessage */
                contentWindow.postMessage(['pageURL', url], '*')

                /* check for lead source cookie */
                const leadSource = getCookie('lead_src')

                if (leadSource) {
                    /* send lead source cookie via postMessage */
                    contentWindow.postMessage(['lead_src', leadSource], '*')
                }
            }
        })
    }
};

window.getCookie = function(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))

    if (match) {
        return match[2]
    }

    return false
}
